import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {WfIssueCommentContainerModel} from "../../../../../../models";
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class WfIssueCommentBackofficeEpService extends BaseApiTemplateService<WfIssueCommentContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-comments/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-comments/backoffice-ep';
    this.httpClient = http;
  }

  uploadFile(formData: FormData, issueCommentGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>>{
    let url = this.apiUrl + "/file/" + issueCommentGuid + "/upload";
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/file/" + issueCommentGuid + "/upload";
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  replaceFile(formData: FormData, extGuid: string, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + extGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(url, formData, this.getHttpHeader(visa));
  }

  getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + '/file/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/file/' + extGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}
